export default {
    data() {
        return {
            selectedOption: {
                name: '',
            },
            showMenu: false,
            placeholderText: 'Please select an item',
        }
    },
    props: {
        options: {
            type: [Array, Object]
        },
        selected: {},
        placeholder: [String],
        closeOnOutsideClick: {
            type: [Boolean],
            default: true,
        },
    },
    mounted() {
        this.selectedOption = this.options[0];
        if (this.placeholder)
        {
            this.placeholderText = this.placeholder;
        }
        if (this.closeOnOutsideClick) {
            document.addEventListener('click', this.clickHandler);
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.clickHandler);
    },
    methods: {
        updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit('updateOption', this.selectedOption);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        clickHandler(event) {
            const { target } = event;
            const { $el } = this;
            if (!$el.contains(target)) {
                this.showMenu = false;
            }
        },
    }
}